// src/pages/CrmCustomers/crmCustomersSlice.js
import { createSlice } from "@reduxjs/toolkit";
import {
  fetchCrmCustomers,
  fetchCrmCustomerGroups,
  fetchCrmCustomerCode,
  saveCrmCustomer,
} from "./crmCustomersThunks";

const crmCustomersSlice = createSlice({
  name: "crmCustomers",
  initialState: {
    crmCustomers: [],
    crmCustomerGroups: [],
    selectedCustomer: null,
    isEditCustomer: false,
    crmCustomerCode: null,
    loading: false,
    error: null,
  },
  reducers: {
    setSelectedCustomer: (state, action) => {
      state.selectedCustomer = action.payload;
    },
    setIsEditCustomer: (state, action) => {
      state.isEditCustomer = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCrmCustomers.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCrmCustomers.fulfilled, (state, action) => {
        state.loading = false;
        state.crmCustomers = action.payload;
      })
      .addCase(fetchCrmCustomers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(fetchCrmCustomerGroups.fulfilled, (state, action) => {
        state.crmCustomerGroups = action.payload;
      })
      .addCase(fetchCrmCustomerCode.fulfilled, (state, action) => {
        state.crmCustomerCode = action.payload;
      })
      .addCase(saveCrmCustomer.fulfilled, (state) => {
        state.isEditCustomer = false;
        state.selectedCustomer = null;
      });
  },
});

export const { setSelectedCustomer, setIsEditCustomer } = crmCustomersSlice.actions;
export default crmCustomersSlice.reducer;
